// extracted by mini-css-extract-plugin
export default {"small_categores_item":"style_small_categores_item__9TcsU","mini_ban_img":"style_mini_ban_img__UupT-"};